<template>
    <div class="d-flex justify-content-end align-items-center py-1 container-lg" v-if="node">
        <a href="#" class="btn btn-primary btn-sm"
            @click.prevent="$emit('clickShare')"><i class="icon-share me-2"></i>シェア</a>
        <a href="#" class="btn btn-primary btn-sm ms-2" v-if="(typeof node.weight !== 'undefined') && node.weight == 0"
            @click.prevent="$emit('clickMarking')"><i class="fas fa-plus me-2"></i>マイメモリーに追加</a>
        <a :href="node.links.admin" class="btn btn-default btn-sm ms-2"
            v-if="node.links.admin && node.editable"><i class="fas fa-edit me-2"></i>編集</a>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'NodeToolbox',
    emits: ['clickSahre', 'clickMarking'],
    props: {
        node: {
            type: Object,
            default: null,
            required: true,
        },
    },
});
</script>
